import {APP_INITIALIZER, Provider} from '@angular/core';
import {PayloadProtectionService} from './payload-protection.service';

/**
 * Forces {@link PayloadProtectionService} to exist at bootstrap. ApiHelper reaches it through its
 * static accessor rather than DI, so nothing else would ever construct it - and without it any
 * protected response fails to decode. Every portal module provides this: the server can protect an
 * endpoint for any caller, not only students.
 *
 * Constructing the service costs nothing; the session key is only fetched on the first protected
 * response.
 */
export const PAYLOAD_PROTECTION_INITIALIZER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: () => () => undefined,
    deps: [PayloadProtectionService],
    multi: true
};
